<!--
 * @Author: 罗川平 2150673512@qq.com
 * @Date: 2026-03-26 14:57:26
 * @LastEditors: redu125 alSZBayxDwQnKd60.redu125@noreply.gitcode.com
 * @LastEditTime: 2026-09-18 10:12:31
 * @FilePath: \watherfocast2\src\views\HomeView.vue
 * @Description: 首页 - 地图网格效果 + 左右两侧卡片 + 底部预测流量统计
-->
<template>
  <div class="homeViewBody">
    <div class="homeViewHeader">
      水电站精细化来水预测平台
      <div class="timeBox">
        {{ currentTime }}
      </div>
      <div class="locBox"></div>
    </div>
    <div class="myheaderBtnBox">
      <div class="myheaderBtnitem">首页</div>
      <div class="myheaderBtnitem" @click="goToStatistics">统计查询</div>
      <div class="myheaderBtnitem" @click="goToPrediction">预测分析</div>
      <div class="myheaderBtnitem" @click="goToManual">使用手册</div>
      <!-- <div class="myheaderBtnitem" v-if="isAdmin" @click="goToAdminPermission">权限管理</div> -->
      <div class="myheaderBtnitem user-menu" @click="handleLogout">
        <i class="el-icon-user-solid"></i>
        退出登录
      </div>
    </div>
    <div v-if="warningData" class="warning-banner" :class="'warning-' + (warningData.severity || '').toLowerCase()">
      <div class="warning-icon">
        <i class="el-icon-warning"></i>
      </div>
      <div class="warning-content">
        <div class="warning-headline">{{ warningData.headline }}</div>
        <div class="warning-desc">{{ warningData.description }}</div>
      </div>
      <div class="warning-close" @click="warningData = null">
        <i class="el-icon-close"></i>
      </div>
    </div>
    <div class="homeMainBox">
      <div v-if="pageLoading" class="loading-overlay">
        <div class="loading-spinner">
          <i class="el-icon-loading"></i>
          <p>数据加载中...</p>
        </div>
      </div>

      <div class="mainLayout">
        <div class="leftColumn">
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">操作</div>
                <div class="operation-content">
                  <div class="operation-item">
                    <span class="label">水电站:</span>
                    <el-select v-if="isAdmin" v-model="adminSelectedStation" placeholder="请选择站点" style="width: 200px" @change="onAdminStationChange">
                      <el-option v-for="opt in stationOptions" :key="opt.find" :label="opt.station_name" :value="opt.find"></el-option>
                    </el-select>
                    <span v-else class="station-name">{{ hyStation }}</span>
                  </div>
                  <div class="operation-item">
                    <span class="label">时间:</span>
                    <el-date-picker
                      v-model="selectedDate"
                      type="date"
                      placeholder="选择日期"
                      format="yyyy-MM-dd"
                      value-format="yyyy-MM-dd HH:mm:ss"
                      style="width: 200px"
                    >
                    </el-date-picker>
                  </div>
                  <div class="operation-item">
                    <span class="label">模型:</span>
                    <div class="radio-group" style="width: 200px;">
                       <label class="radio-label" style="width:100px">
                        <input type="radio" name="modelType" value="1" v-model="selectedModel"> 拟合模型
                      </label>
                      <label class="radio-label" style="width:100px">
                        <input type="radio" name="modelType" value="0" v-model="selectedModel"> 神经网络
                      </label>
                     
                    </div>
                  </div>
                  <div class="operation-item2">
                    <button class="confirm-btn" @click="fetchData">确认</button>
                  </div>
                  <!-- <div class="operation-item2">
                    <button class="confirm-btn green">导入</button>
                    <button class="confirm-btn green">训练</button>
                  </div> -->
                  <div class="operation-item3">
                    <button class="text-btn" @click="openFlowEntry">
                      <i class="el-icon-link"></i> 流量录入
                    </button>
                    <!-- 暂时隐藏区间流量录入 -->
                    <!-- <button class="text-btn" @click="goToIntervalFlowEntry">
                      <i class="el-icon-link"></i> 区间流量录入
                    </button> -->
                    <!-- 暂时隐藏上游流量录入 -->
                    <!-- <button v-if="stationId === '513201'" class="text-btn" @click="goToUpstreamFlow">
                      <i class="el-icon-link"></i> 上游流量录入
                    </button> -->
                    <button v-if="effectiveStationId === '513201'" class="text-btn" @click="goToOutFlow">
                      <i class="el-icon-link"></i> 出库流量录入
                    </button>
                  </div>
                </div>
              </div>
            </dv-border-box-8>
          </div>
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">检验结果</div>
                <div class="chart-actions">
                  <button class="action-btn icon-only" @click="toggleInspectionFullscreen">
                    <i class="el-icon-full-screen"></i>
                  </button>
                </div>
                <div ref="inspectionChart" class="chart-content"></div>
              </div>
            </dv-border-box-8>
          </div>
        </div>

        <div class="centerColumn">
          <div class="card map-card">
            <dv-border-box-8>
              <div class="chart-container map-container">
                <div class="map-header-row">
                  <span class="chart-title">面雨量预测分布图</span>
                  <button class="action-btn icon-only" @click="toggleMapFullscreen">
                    <i class="el-icon-full-screen"></i>
                  </button>
                </div>
                <div ref="rainfallMap" id="homeMap" class="map-chart"></div>
                <forecast-playback
                  :dates="rainfallDates"
                  :index="rainfallFrameIndex"
                  :playing="rainfallPlaying"
                  :loading="rainfallLoading"
                  @toggle="toggleRainfallPlayback"
                  @seek="seekRainfallFrame"
                />
                <div class="map-opacity-slider">
                  <span class="opacity-label">格点透明度</span>
                  <input
                    type="range"
                    min="30"
                    max="255"
                    :value="gridOpacity"
                    @input="updateGridOpacity"
                    class="opacity-range"
                  />
                  <span class="opacity-value">{{ Math.round(gridOpacity / 255 * 100) }}%</span>
                </div>
              </div>
            </dv-border-box-8>
          </div>
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">预测流量统计</div>
                <div class="chart-actions">
                  <button class="action-btn icon-only" @click="toggleDailyFullscreen">
                    <i class="el-icon-full-screen"></i>
                  </button>
                  <button class="action-btn" @click="downloadDailyChart">下载图片</button>
                  <button class="action-btn" @click="toggleDailyTable">{{ showDailyTable ? '图表显示' : '表格显示' }}</button>
                </div>
                <div v-show="!showDailyTable" ref="dailyChart" class="chart-content"></div>
                <div v-if="showDailyTable" class="table-content">
                  <table>
                    <thead>
                      <tr>
                        <th>日期</th>
                        <th>逐日流量(m³/s)</th>
                        <th>区间流量(m³/s)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in dailyTableData" :key="index">
                        <td>{{ item.datetime.substring(5, 10) }}</td>
                        <td>{{ item.flow || 0 }}</td>
                        <td>{{ item.intervalFlow }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </dv-border-box-8>
          </div>
        </div>

        <div class="rightColumn">
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-actions">
                  <button class="action-btn icon-only" @click="toggleRainfallFullscreen">
                    <i class="el-icon-full-screen"></i>
                  </button>
                </div>
                <div class="radio-group">
                  <label class="radio-label">
                    <input type="radio" name="dataMode" value="flow" v-model="currentDataMode"> 流量数据
                  </label>
                  <label class="radio-label">
                    <input type="radio" name="dataMode" value="daily" v-model="currentDataMode"> 逐日雨量
                  </label>
                  <label class="radio-label">
                    <input type="radio" name="dataMode" value="hourly" v-model="currentDataMode"> 面雨量
                  </label>
                </div>
                <div ref="rainfallChart" class="chart-content"></div>
              </div>
            </dv-border-box-8>
          </div>
          <div class="card">
            <dv-border-box-8>
              <div class="chart-container">
                <div class="chart-title">实际与预测对比</div>
                <div class="chart-actions">
                  <button class="action-btn icon-only" @click="toggleComparisonFullscreen">
                    <i class="el-icon-full-screen"></i>
                  </button>
                </div>
                <div ref="comparisonChart" class="chart-content"></div>
              </div>
            </dv-border-box-8>
          </div>
        </div>
      </div>
    </div>
    <div v-if="comparisonFullscreen" class="fullscreen-overlay" @click.self="toggleComparisonFullscreen">
      <div class="fullscreen-chart-container">
        <div class="fullscreen-header">
          <span class="fullscreen-title">实际与预测对比</span>
          <button class="fullscreen-close-btn" @click="toggleComparisonFullscreen">
            <i class="el-icon-close"></i> 关闭
          </button>
        </div>
        <div ref="comparisonFullscreenChart" class="fullscreen-chart-content"></div>
      </div>
    </div>
    <div v-if="rainfallFullscreen" class="fullscreen-overlay" @click.self="toggleRainfallFullscreen">
      <div class="fullscreen-chart-container">
        <div class="fullscreen-header">
          <span class="fullscreen-title">{{ rainfallFullscreenTitle }}</span>
          <button class="fullscreen-close-btn" @click="toggleRainfallFullscreen">
            <i class="el-icon-close"></i> 关闭
          </button>
        </div>
        <div ref="rainfallFullscreenChart" class="fullscreen-chart-content"></div>
      </div>
    </div>
    <div v-if="inspectionFullscreen" class="fullscreen-overlay" @click.self="toggleInspectionFullscreen">
      <div class="fullscreen-chart-container">
        <div class="fullscreen-header">
          <span class="fullscreen-title">检验结果</span>
          <button class="fullscreen-close-btn" @click="toggleInspectionFullscreen">
            <i class="el-icon-close"></i> 关闭
          </button>
        </div>
        <div ref="inspectionFullscreenChart" class="fullscreen-chart-content"></div>
      </div>
    </div>
    <div v-if="mapFullscreen" class="fullscreen-overlay">
      <div class="fullscreen-map-container">
        <div class="fullscreen-header">
          <span class="fullscreen-title">面雨量预测分布图</span>
          <button class="fullscreen-close-btn" @click="toggleMapFullscreen">
            <i class="el-icon-close"></i> 关闭
          </button>
        </div>
        <div ref="mapFullscreenContainer" class="fullscreen-map-content"></div>
        <forecast-playback
          :dates="rainfallDates"
          :index="rainfallFrameIndex"
          :playing="rainfallPlaying"
          :loading="rainfallLoading"
          @toggle="toggleRainfallPlayback"
          @seek="seekRainfallFrame"
        />
      </div>
    </div>
    <div v-if="dailyFullscreen" class="fullscreen-overlay" @click.self="toggleDailyFullscreen">
      <div class="fullscreen-chart-container">
        <div class="fullscreen-header">
          <span class="fullscreen-title">预测流量统计</span>
          <button class="fullscreen-close-btn" @click="toggleDailyFullscreen">
            <i class="el-icon-close"></i> 关闭
          </button>
        </div>
        <div ref="dailyFullscreenChart" class="fullscreen-chart-content"></div>
      </div>
    </div>
    <div class="copyright-footer">@2026 四川科达乐能源有限公司联合四川省气象局联合开发</div>
  </div>
</template>

<script>
import * as echarts from 'echarts'
import axios from 'axios'
import * as L from 'leaflet'
import { MapCreate, legendColor } from '../map/mapImport.js'
import { createWaterSystemLayer } from '../map/waterSystemLayer'
import stationIcon from '../assets/shuidian.png'
import { isAdmin as hasAdminRole, getDefaultFind, clearAuth, setSilentOnAuthFail } from '../utils/auth'
import { API_BASE, FLOW_ENTRY_URL, GRID_RAINFALL_FORECAST_URL, getStationBasinURL } from '../api/config'
import ForecastPlayback from '../components/ForecastPlayback.vue'

export default {
  name: 'HomeView',
  components: { ForecastPlayback },
  data() {
    return {
      comparisonChartInstance: null,
      comparisonFullscreenChartInstance: null,
      comparisonFullscreen: false,
      dailyChartInstance: null,
      dailyFullscreenChartInstance: null,
      dailyFullscreen: false,
      inspectionChartInstance: null,
      inspectionFullscreenChartInstance: null,
      inspectionFullscreen: false,
      rainfallChartInstance: null,
      rainfallFullscreenChartInstance: null,
      rainfallFullscreen: false,
      currentDataMode: 'flow',
      currentTime: '',
      hyStation: localStorage.getItem('hyStation') || '竹格多水电站',
      stationId: localStorage.getItem('stationId') || '',
      adminSelectedStation: getDefaultFind(),
      stationOptions: [],
      selectedDate: '2026-03-29 00:00:00',
      selectedModel: '1',
      currentDayRainData: [],
      currentHourRainData: [],
      currentDayRealRainData: [],
      comparisonData: {
        dates: [],
        actual: [],
        predicted: [],
        actualFlow: [],
        predictedName: '预测流量',
        actualName: '实际流量'
      },
      showDailyTable: false,
      dailyTableData: [],
      pageLoading: false,
      warningData: null,
      warningAutoCloseTimer: null,
      mapData: null,
      mapFullscreen: false,
      mapFullscreenInstance: null,
      gridDataLayer: null,
      gridLinesLayer: null,
      gridValuesLayer: null,
      gridLegend: null,
      gridOpacity: 230,
      gridDataCache: null,
      gridListCache: null,
      rainfallFrames: [],
      rainfallFrameIndex: 0,
      rainfallPlaying: false,
      rainfallTimer: null,
      rainfallLoading: false,
      fullscreenGridLayers: [],
      fullscreenGridLegend: null,
      // 请求代际序号：切站/清数据时自增，使在途请求的迟到响应直接丢弃
      gridReqSeq: 0,
      drainReqSeq: 0,
      markerReqSeq: 0,
      fullMapSeq: 0,
      fetchReqSeq: 0,
      stationMarkersLayer: null,
      drainLayer: null
    }
  },
  mounted() {
    this.selectedDate = this.getYesterday()
    this.updateTime()
    this.initComparisonChart()
    this.initDailyChart()
    this.initInspectionChart()
    this.initRainfallChart()
    this.initMap()
    this.fetchData()
    this.fetchWarning()
    window.addEventListener('resize', this.handleResize)
    setInterval(() => {
      this.updateTime()
    }, 1000)
  },
  beforeDestroy() {
    this.clearGridData()
    window.removeEventListener('resize', this.handleResize)
    if (this.warningAutoCloseTimer) {
      clearTimeout(this.warningAutoCloseTimer)
      this.warningAutoCloseTimer = null
    }
    if (this.comparisonChartInstance) {
      this.comparisonChartInstance.dispose()
    }
    if (this.comparisonFullscreenChartInstance) {
      this.comparisonFullscreenChartInstance.dispose()
    }
    if (this.dailyChartInstance) {
      this.dailyChartInstance.dispose()
    }
    if (this.dailyFullscreenChartInstance) {
      this.dailyFullscreenChartInstance.dispose()
    }
    if (this.inspectionChartInstance) {
      this.inspectionChartInstance.dispose()
    }
    if (this.inspectionFullscreenChartInstance) {
      this.inspectionFullscreenChartInstance.dispose()
    }
    if (this.rainfallChartInstance) {
      this.rainfallChartInstance.dispose()
    }
    if (this.rainfallFullscreenChartInstance) {
      this.rainfallFullscreenChartInstance.dispose()
    }
    if (this.mapFullscreenInstance && this.mapFullscreenInstance.map) {
      this.mapFullscreenInstance.map.remove()
      this.mapFullscreenInstance = null
    }
  },
  computed: {
    rainfallDates() {
      return this.rainfallFrames.map(frame => frame.data.fTime)
    },
    isAdmin() {
      return hasAdminRole()
    },
    effectiveStationId() {
      return this.isAdmin ? this.adminSelectedStation : getDefaultFind()
    },
    rainfallFullscreenTitle() {
      const titles = { flow: '流量数据', daily: '逐日雨量', hourly: '面雨量' }
      return titles[this.currentDataMode] || '雨量数据'
    }
  },
  watch: {
    currentDataMode() {
      this.updateRainfallChart()
    }
  },
  methods: {
    goToStatistics() {
      this.$router.push({ name: 'Statistics' })
    },
    goToPrediction() {
      this.$router.push({ name: 'Predictive' })
    },
    goToManual() {
      this.$router.push({ name: 'UserManual' })
    },
    goToAdminPermission() {
      this.$router.push('/admin')
    },
    goToUpstreamFlow() {
      window.open(`${FLOW_ENTRY_URL}/#/upstream-flow-entry`, '_blank')
    },
    goToOutFlow() {
      window.open(`${FLOW_ENTRY_URL}/#/out-flow-entry`, '_blank')
    },
    goToIntervalFlowEntry() {
      window.open(`${FLOW_ENTRY_URL}/#/interval-flow-entry`, '_blank')
      // this.$router.push({ name: 'IntervalFlowEntry' })
    },
    handleLogout() {
      this.$confirm('确定要退出登录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        localStorage.removeItem('rememberedUser')
        // 主动退出登录，后续接口 401/403 不再弹框，避免多个提示叠加
        setSilentOnAuthFail(true)
        clearAuth()
        this.$message.success('已退出登录')
        this.$router.push('/login')
      }).catch(() => {})
    },
    onAdminStationChange() {
      this.warningData = null
      this.clearGridData()
      this.fetchDrainGeoJSON()
      this.fetchStationMarkers()
      this.fetchData()
      this.fetchWarning()
    },
    updateTime() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      const hours = String(now.getHours()).padStart(2, '0')
      const minutes = String(now.getMinutes()).padStart(2, '0')
      const seconds = String(now.getSeconds()).padStart(2, '0')
      const weekDays = ['星期日', '星期一', '星期二', '星期三', '星期四', '星期五', '星期六']
      const weekDay = weekDays[now.getDay()]
      this.currentTime = `${year}-${month}-${day} ${hours}:${minutes}:${seconds} ${weekDay}`
    },
    async fetchWarning() {
      try {
        const formData = new FormData()
        formData.append('find', this.effectiveStationId || '')
        const response = await axios.post(`${API_BASE}/api/warn/warning`, formData)
        // 有数据就显示弹窗
        if (response.data && response.data.code === 200 && response.data.data) {
          this.warningData = response.data.data
        } else {
          this.warningData = null
        }
      } catch {
        this.warningData = null
      }
      if (this.warningAutoCloseTimer) {
        clearTimeout(this.warningAutoCloseTimer)
        this.warningAutoCloseTimer = null
      }
      // severity 为 Green（良好）时 5 秒后自动关闭，其他严重等级需手动关闭
        if (this.warningData && this.warningData.severity === 'Green') {
          this.warningAutoCloseTimer = setTimeout(() => {
            this.warningData = null
            this.warningAutoCloseTimer = null
          }, 5000)
        }
    },
    getYesterday() {
      const yesterday = new Date()
      yesterday.setDate(yesterday.getDate() - 1)
      const year = yesterday.getFullYear()
      const month = String(yesterday.getMonth() + 1).padStart(2, '0')
      const day = String(yesterday.getDate()).padStart(2, '0')
      return `${year}-${month}-${day} 00:00:00`
    },
    getLatestRainfallDate() {
      const now = new Date()
      const year = now.getFullYear()
      const month = String(now.getMonth() + 1).padStart(2, '0')
      const day = String(now.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    initComparisonChart() {
      this.comparisonChartInstance = echarts.init(this.$refs.comparisonChart)
      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        grid: { top: 40, bottom: 10, left: 55, right: 15 },
        legend: {
          data: [this.comparisonData.predictedName, this.comparisonData.actualName],
          textStyle: { color: '#fff' },
          top: 5
        },
        xAxis: {
          type: 'category',
          data: [],
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '流量(m³/s)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [
          {
            name: this.comparisonData.predictedName,
            type: 'line',
            data: [],
            smooth: true,
            itemStyle: { color: '#ffaa00' },
            lineStyle: { width: 2 }
          },
          {
            name: this.comparisonData.actualName,
            type: 'line',
            data: [],
            smooth: true,
            itemStyle: { color: '#67c23a' },
            lineStyle: { width: 2 }
          }
        ]
      }
      this.comparisonChartInstance.setOption(option)
    },
    initDailyChart() {
      this.dailyChartInstance = echarts.init(this.$refs.dailyChart)
      const option = {
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        legend: {
          data: ['逐日流量', '区间流量'],
          textStyle: { color: '#ccc' }
        },
        xAxis: {
          type: 'category',
          data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '流量(m³/s)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [
          {
            name: '逐日流量',
            type: 'bar',
            data: [150, 180, 160, 200, 220, 190, 170],
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#00d8ff' }, { offset: 1, color: '#006e99' }] } },
            label: { show: true, position: 'top', color: '#00d8ff', fontSize: 10, formatter: (p) => (typeof p.value === 'number' ? p.value.toFixed(2) : p.value) }
          },
          {
            name: '区间流量',
            type: 'bar',
            data: [75, 90, 80, 100, 110, 95, 85],
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#67c23a' }, { offset: 1, color: '#3a8a1f' }] } },
            label: { show: true, position: 'top', color: '#67c23a', fontSize: 10, formatter: (p) => (typeof p.value === 'number' ? p.value.toFixed(2) : p.value) }
          },
          {
            name: '逐日趋势',
            type: 'line',
            data: [150, 180, 160, 200, 220, 190, 170],
            smooth: true,
            itemStyle: { color: '#00d8ff' },
            lineStyle: { width: 2 },
            tooltip: { show: false }
          },
          {
            name: '区间趋势',
            type: 'line',
            data: [75, 90, 80, 100, 110, 95, 85],
            smooth: true,
            itemStyle: { color: '#67c23a' },
            lineStyle: { width: 2 },
            tooltip: { show: false }
          }
        ]
      }
      this.dailyChartInstance.setOption(option)
    },
    initInspectionChart() {
      this.inspectionChartInstance = echarts.init(this.$refs.inspectionChart)
      const dates = []
      const scores = []
      const today = new Date()
      for (let i = 9; i >= 0; i--) {
        const date = new Date(today)
        date.setDate(date.getDate() - i)
        const month = date.getMonth() + 1
        const day = date.getDate()
        dates.push(`${month}/${day}`)
        scores.push(Math.floor(Math.random() * 30) + 70)
      }
      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '检验评分',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [{
          name: '检验评分',
          type: 'line',
          data: scores,
          smooth: true,
          itemStyle: { color: '#00d8ff' },
          areaStyle: {
            color: {
              type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(0, 216, 255, 0.5)' },
                { offset: 1, color: 'rgba(0, 216, 255, 0.1)' }
              ]
            }
          }
        }]
      }
      this.inspectionChartInstance.setOption(option)
    },
    initRainfallChart() {
      this.rainfallChartInstance = echarts.init(this.$refs.rainfallChart)
      const option = this.getRainfallChartOption('daily')
      this.rainfallChartInstance.setOption(option)
    },
    getRainfallChartOption(mode) {
      if (mode === 'daily') {
        return {
          tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
          xAxis: {
            type: 'category',
            data: ['周一', '周二', '周三', '周四', '周五', '周六', '周日'],
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' }
          },
          yAxis: {
            type: 'value',
            name: '雨量(mm)',
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' },
            splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
          },
          series: [{
            name: '逐日雨量',
            type: 'bar',
            data: [25, 32, 18, 45, 38, 22, 15],
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#00d8ff' }, { offset: 1, color: '#006e99' }] } },
            label: { show: true, position: 'top', color: '#00d8ff', fontSize: 10, formatter: (p) => p.value }
          }]
        }
      } else if (mode === 'hourly') {
        return {
          tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
          xAxis: {
            type: 'category',
            data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00'],
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' }
          },
          yAxis: {
            type: 'value',
            name: '雨量(mm)',
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' },
            splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
          },
          series: [{
            name: '逐时雨量',
            type: 'line',
            data: [5, 8, 12, 15, 10, 7, 3, 6, 9, 11, 8, 4],
            smooth: true,
            itemStyle: { color: '#00d8ff' },
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [{ offset: 0, color: 'rgba(0, 216, 255, 0.5)' }, { offset: 1, color: 'rgba(0, 216, 255, 0.1)' }]
              }
            }
          }]
        }
      } else {
        return {
          tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
          xAxis: {
            type: 'category',
            data: ['00:00', '02:00', '04:00', '06:00', '08:00', '10:00', '12:00', '14:00', '16:00', '18:00', '20:00', '22:00'],
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' }
          },
          yAxis: {
            type: 'value',
            name: '流量(m³/s)',
            axisLine: { lineStyle: { color: '#fff' } },
            axisLabel: { color: '#ccc' },
            splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
          },
          series: [{
            name: '流量数据',
            type: 'line',
            data: [120, 132, 101, 134, 190, 230, 210, 180, 160, 175, 190, 150],
            smooth: true,
            itemStyle: { color: '#00d8ff' },
            areaStyle: {
              color: {
                type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
                colorStops: [{ offset: 0, color: 'rgba(0, 216, 255, 0.5)' }, { offset: 1, color: 'rgba(0, 216, 255, 0.1)' }]
              }
            }
          }]
        }
      }
    },
    updateRainfallChart() {
      if (this.currentDataMode === 'daily') {
        this.updateDayRainChart(this.forrain, this.trueRain)
      } else if (this.currentDataMode === 'hourly') {
        this.updateHourRainChart(this.currentHourRainData)
      } else {
        this.updateFlowChart(this.currentDayRealRainData, this.currentDayRainData)
      }
    },
    handleResize() {
      if (this.comparisonChartInstance) this.comparisonChartInstance.resize()
      if (this.comparisonFullscreenChartInstance) this.comparisonFullscreenChartInstance.resize()
      if (this.dailyChartInstance) this.dailyChartInstance.resize()
      if (this.dailyFullscreenChartInstance) this.dailyFullscreenChartInstance.resize()
      if (this.inspectionChartInstance) this.inspectionChartInstance.resize()
      if (this.inspectionFullscreenChartInstance) this.inspectionFullscreenChartInstance.resize()
      if (this.rainfallChartInstance) this.rainfallChartInstance.resize()
      if (this.rainfallFullscreenChartInstance) this.rainfallFullscreenChartInstance.resize()
      if (this.mapData && this.mapData.map) this.mapData.map.invalidateSize()
      if (this.mapFullscreenInstance && this.mapFullscreenInstance.map) this.mapFullscreenInstance.map.invalidateSize()
    },
    openFlowEntry() {
      window.open(`${FLOW_ENTRY_URL}/#/flow-entry`, '_blank')
    },
    downloadDailyChart() {
      if (this.dailyChartInstance) {
        const link = document.createElement('a')
        link.download = '逐日流量预测.png'
        link.href = this.dailyChartInstance.getDataURL()
        link.click()
      }
    },
    toggleDailyTable() {
      if (this.showDailyTable) {
        if (!this.dailyChartInstance) {
          this.initDailyChart()
          if (this.dailyTableData && this.dailyTableData.length > 0) {
            this.updateDailyChart(this.dailyTableData)
          }
        }
      }
      this.showDailyTable = !this.showDailyTable
    },
    toggleComparisonFullscreen() {
      if (this.comparisonFullscreen) {
        if (this.comparisonFullscreenChartInstance) {
          this.comparisonFullscreenChartInstance.dispose()
          this.comparisonFullscreenChartInstance = null
        }
        this.comparisonFullscreen = false
      } else {
        this.comparisonFullscreen = true
        this.$nextTick(() => {
          this.comparisonFullscreenChartInstance = echarts.init(this.$refs.comparisonFullscreenChart)
          if (this.comparisonChartInstance) {
            const option = this.comparisonChartInstance.getOption()
            this.comparisonFullscreenChartInstance.setOption(option)
          }
          this.comparisonFullscreenChartInstance.resize()
        })
      }
    },
    toggleRainfallFullscreen() {
      if (this.rainfallFullscreen) {
        if (this.rainfallFullscreenChartInstance) {
          this.rainfallFullscreenChartInstance.dispose()
          this.rainfallFullscreenChartInstance = null
        }
        this.rainfallFullscreen = false
      } else {
        this.rainfallFullscreen = true
        this.$nextTick(() => {
          this.rainfallFullscreenChartInstance = echarts.init(this.$refs.rainfallFullscreenChart)
          if (this.rainfallChartInstance) {
            const option = this.rainfallChartInstance.getOption()
            this.rainfallFullscreenChartInstance.setOption(option)
          }
          this.rainfallFullscreenChartInstance.resize()
        })
      }
    },
    toggleInspectionFullscreen() {
      if (this.inspectionFullscreen) {
        if (this.inspectionFullscreenChartInstance) {
          this.inspectionFullscreenChartInstance.dispose()
          this.inspectionFullscreenChartInstance = null
        }
        this.inspectionFullscreen = false
      } else {
        this.inspectionFullscreen = true
        this.$nextTick(() => {
          this.inspectionFullscreenChartInstance = echarts.init(this.$refs.inspectionFullscreenChart)
          if (this.inspectionChartInstance) {
            const option = this.inspectionChartInstance.getOption()
            this.inspectionFullscreenChartInstance.setOption(option)
          }
          this.inspectionFullscreenChartInstance.resize()
        })
      }
    },
    toggleMapFullscreen() {
      if (this.mapFullscreen) {
        this.fullMapSeq++
        this.clearFullscreenGridLayers()
        if (this.mapFullscreenInstance && this.mapFullscreenInstance.map) {
          this.mapFullscreenInstance.map.remove()
          this.mapFullscreenInstance = null
        }
        this.mapFullscreen = false
        this.$nextTick(() => {
          if (this.mapData && this.mapData.map) {
            this.mapData.map.invalidateSize()
          }
        })
      } else {
        this.mapFullscreen = true
        this.$nextTick(() => {
          const fullMap = new MapCreate()
          this.mapFullscreenInstance = fullMap
          const mapObj = fullMap.init(this.$refs.mapFullscreenContainer)
          // 代际快照：全屏地图关闭/重建后，旧异步回调直接失效
          const fullSeq = ++this.fullMapSeq
          const stationId = this.effectiveStationId || ''
          const isStale = () => fullSeq !== this.fullMapSeq || this.mapFullscreenInstance !== fullMap || stationId !== (this.effectiveStationId || '')
          createWaterSystemLayer(mapObj).addTo(mapObj)

          const loadDrain = () => {
            return this.fetchDrainFeatures().then((allFeatures) => {
              if (isStale()) return
              if (allFeatures.length > 0) {
                L.geoJSON(allFeatures, { color: 'red', fillOpacity: 0, className: 'dashLine' }).addTo(mapObj)
              }
            })
          }

          const loadStationMarkers = () => {
            return axios({
              url: `${API_BASE}/api/hydro/getHydroSearch`,
              method: 'get',
              params: { find: this.effectiveStationId || '' }
            }).then((res) => {
              if (isStale()) return
              if (res.data.code !== 200 || !Array.isArray(res.data.data)) return
              this.addStationMarkers(res.data.data, mapObj)
            }).catch((error) => {
              console.error('全屏地图加载水电站标记失败:', error)
            })
          }

          this.renderFullscreenRainfallFrame(true)
          if (!this.rainfallFrames.length && !this.rainfallLoading) this.getGridData()
          Promise.all([loadDrain(), loadStationMarkers()])
        })
      }
    },
    toggleDailyFullscreen() {
      if (this.dailyFullscreen) {
        if (this.dailyFullscreenChartInstance) {
          this.dailyFullscreenChartInstance.dispose()
          this.dailyFullscreenChartInstance = null
        }
        this.dailyFullscreen = false
      } else {
        this.dailyFullscreen = true
        this.$nextTick(() => {
          this.dailyFullscreenChartInstance = echarts.init(this.$refs.dailyFullscreenChart)
          if (this.dailyChartInstance) {
            const option = this.dailyChartInstance.getOption()
            this.dailyFullscreenChartInstance.setOption(option)
          }
          this.dailyFullscreenChartInstance.resize()
        })
      }
    },
    async fetchData() {
      this.pageLoading = true
      this.getGridData()
      try {
        const queryStationId = this.effectiveStationId || ''
        const response = await axios.post(`${API_BASE}/api/hydro/InspectionDayHourResults?date=${this.selectedDate}&type=${this.selectedModel}&find=${queryStationId}`)
        if (response.data.success || response.data.code == 200) {
          const data = response.data.data
          if (!data) {
            console.warn('InspectionDayHourResults 返回 data 为空:', response.data)
            return
          }
          // 老平台的 dayRealRain 是实际流量；dayRain 才是实际雨量。
          this.currentDayRainData = (data.dayRain || []).map(item => ({ datetime: item.datetime, rainfall: item.dayPredictRained }))
          this.currentHourRainData = (data.hourRain || []).map(item => ({ datetime: item.datetime, rainfall: item.PredictRained }))
          this.currentDayRealRainData = (data.dayRealRain || []).map(item => ({ datetime: item.datetime, flow: item.PredictRealRained }))
          this.trueRain = (data.dayRain || []).map(item => ({ datetime: item.datetime, rainfall: item.dayPredictRained }))
          this.forrain = (data.dayPredictRained || []).map(item => ({ datetime: item.datetime, rainfall: item.dayPredictRained }))
          this.updateInspectionChart((data.InspectionResults || []).map(item => ({ datetime: item.date_time, accuracy: item.error_value })))
          this.updateDailyChart((data.dayPredictTraffic || []).map(item => ({ datetime: item.daytime, flow: item.dayPredictPredictTraffic })))
          this.updateComparisonData(data)
          this.updateComparisonChart(this.comparisonData)
          this.updateRainfallChart()
        }
      } catch (error) {
        console.error('获取数据失败:', error)
      } finally {
        this.pageLoading = false
      }
    },
    updateComparisonData(data) {
      const dates = []
      const predicted = []
      const actualFlow = []

      if (data.preRateTraffics && data.preRateTraffics.length > 0) {
        data.preRateTraffics.forEach(item => {
          dates.push(String(item.date || '').substring(5, 10))
          predicted.push(item.fcest == null ? null : Number(item.fcest))
        })
      }

      if (data.preRateTrafficsReal != null && data.preRateTrafficsReal !== '') {
        dates.forEach(() => {
          actualFlow.push(Number(data.preRateTrafficsReal))
        })
      }

      const dayNum = this.selectedDate.substring(8, 10) + '号'
      const predictedName = `过去10天对${dayNum}预测流量`
      const actualName = `${dayNum}实际流量`

      this.comparisonData = {
        dates: dates,
        predicted: predicted,
        actualFlow: actualFlow,
        predictedName: predictedName,
        actualName: actualName
      }
    },
    updateInspectionChart(results) {
      const dates = results.map(item => item.datetime.substring(5, 10))
      const avgPres = results.map(item => (typeof item.accuracy === 'number' ? item.accuracy.toFixed(2) : item.accuracy))
      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        xAxis: {
          type: 'category',
          data: dates,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '检验评分',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [{
          name: '检验评分',
          type: 'line',
          data: avgPres,
          smooth: true,
          itemStyle: { color: '#00d8ff' },
          label: {
            show: true,
            color: '#00d8ff',
            fontSize: 10,
            position: 'top',
            formatter: (p) => p.value
          },
          areaStyle: {
            color: {
              type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [
                { offset: 0, color: 'rgba(0, 216, 255, 0.5)' },
                { offset: 1, color: 'rgba(0, 216, 255, 0.1)' }
              ]
            }
          }
        }]
      }
      this.inspectionChartInstance.setOption(option)
    },
    updateDailyChart(dayData) {
      let timeList = dayData.map(item => item.datetime.substring(5, 10))
      let dailyFlowData = dayData.map(item => item.flow || 0)
      // 区间流量按业务规则取预测流量的一半。
      let intervalFlowData = dailyFlowData.map(flow => Number(flow) / 2)
      this.dailyTableData = dayData.map((item, index) => ({ ...item, intervalFlow: intervalFlowData[index] }))

      const option = {
        tooltip: { trigger: 'axis', axisPointer: { type: 'shadow' }, valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        legend: {
          data: ['逐日流量', '区间流量'],
          textStyle: { color: '#ccc' }
        },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '流量(m³/s)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [
          {
            name: '逐日流量',
            type: 'bar',
            data: dailyFlowData,
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#00d8ff' }, { offset: 1, color: '#006e99' }] } },
            label: { show: true, color: '#fff', fontSize: 11 }
          },
          {
            name: '区间流量',
            type: 'bar',
            data: intervalFlowData,
            itemStyle: { color: { type: 'linear', x: 0, y: 0, x2: 0, y2: 1, colorStops: [{ offset: 0, color: '#67c23a' }, { offset: 1, color: '#3a8a1f' }] } },
            label: { show: true, color: '#fff', fontSize: 11 }
          },
          {
            name: '逐日趋势',
            type: 'line',
            data: dailyFlowData,
            smooth: true,
            itemStyle: { color: '#00d8ff' },
            lineStyle: { width: 2 },
            tooltip: { show: false }
          },
          {
            name: '区间趋势',
            type: 'line',
            data: intervalFlowData,
            smooth: true,
            itemStyle: { color: '#67c23a' },
            lineStyle: { width: 2 },
            tooltip: { show: false }
          }
        ]
      }
      this.dailyChartInstance.setOption(option)
    },
    updateComparisonChart(comparisonData) {
      if (!comparisonData || !comparisonData.dates || comparisonData.dates.length === 0) return
      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        grid: { top: 100, bottom: 10, left: 55, right: 15 },
        legend: {
          data: [comparisonData.predictedName, comparisonData.actualName],
          textStyle: { color: '#fff' },
          top: 30
        },
        xAxis: {
          type: 'category',
          data: comparisonData.dates,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '流量(m³/s)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [
          {
            name: comparisonData.predictedName,
            type: 'line',
            data: comparisonData.predicted,
            smooth: true,
            itemStyle: { color: '#ffaa00' },
            lineStyle: { width: 2 },
            label: {
              show: true,
              color: '#ffaa00',
              fontSize: 10,
              position: 'top',
              formatter: (p) => (typeof p.value === 'number' ? p.value.toFixed(0) : p.value)
            }
          },
          {
            name: comparisonData.actualName,
            type: 'line',
            data: comparisonData.actualFlow,
            smooth: true,
            itemStyle: { color: '#67c23a' },
            lineStyle: { width: 2 },
            label: {
              show: true,
              color: '#67c23a',
              fontSize: 10,
              position: 'bottom',
              formatter: (p) => p.value.toFixed(0)
            }
          }
        ]
      }
      this.comparisonChartInstance.setOption(option, { notMerge: true, lazyUpdate: true })
    },
    updateDayRainChart(dayRainData, dayRealRainData) {
      let actualRainData = dayRealRainData.map(item => item.rainfall || 0)
      let predictedRainData = dayRainData.map(item => item.rainfall || 0)
      let combinedData = [...actualRainData, ...predictedRainData]
      let timeList = []

      dayRealRainData.forEach(item => {
        timeList.push(item.datetime.substring(5, 10))
      })
      dayRainData.forEach(item => {
        timeList.push(item.datetime.substring(5, 10))
      })

      let colorList = []
      for (let i = 0; i < actualRainData.length; i++) colorList.push('#00d8ff')
      for (let i = 0; i < predictedRainData.length; i++) colorList.push('#ffaa00')

      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        legend: {
          data: ['实际雨量', '预测雨量'],
          textStyle: { color: '#fff' },
          top: 10
        },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '雨量(mm)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [{
          name: '雨量',
          type: 'line',
          data: combinedData,
          smooth: true,
          itemStyle: {
            color: function (params) {
              return colorList[params.dataIndex] || '#ffaa00'
            }
          },
          lineStyle: { width: 2 },
          label: {
            show: true,
            position: 'top',
            fontSize: 10,
            color: function (params) {
              return colorList[params.dataIndex] || '#ffaa00'
            },
            formatter: (p) => (typeof p.value === 'number' ? p.value.toFixed(2) : p.value)
          }
        }]
      }
      this.rainfallChartInstance.setOption(option, { notMerge: true, lazyUpdate: true })
    },
    updateHourRainChart(hourRainData) {
      let timeList = hourRainData.map(item => item.datetime.substring(5, 10))
      let rainData = hourRainData.map(item => item.rainfall || 0)
      const option = {
        tooltip: { trigger: 'axis' },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: {
          type: 'value',
          name: '雨量(mm)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        },
        series: [{
          name: '面雨量',
          type: 'line',
          data: rainData,
          smooth: true,
          itemStyle: { color: '#00d8ff' },
          label: { show: true, position: 'top', color: '#00d8ff', fontSize: 10, formatter: (p) => (typeof p.value === 'number' ? p.value.toFixed(2) : p.value) },
          areaStyle: {
            color: {
              type: 'linear', x: 0, y: 0, x2: 0, y2: 1,
              colorStops: [{ offset: 0, color: 'rgba(0, 216, 255, 0.5)' }, { offset: 1, color: 'rgba(0, 216, 255, 0.1)' }]
            }
          }
        }]
      }
      this.rainfallChartInstance.setOption(option, { notMerge: true, lazyUpdate: true })
    },
    updateFlowChart(dayRealRainData, dayRainData) {
      let timeList = dayRealRainData.map(item => item.datetime.substring(5, 10))
      let realFlowData = dayRealRainData.map(item => item.flow || 0)
      let dayRainDataList = dayRealRainData.map(item => {
        const rain = dayRainData.find(row => String(row.datetime).slice(0, 10) === String(item.datetime).slice(0, 10))
        return rain && rain.rainfall != null ? Number(rain.rainfall) : null
      })
      const option = {
        tooltip: { trigger: 'axis', valueFormatter: (value) => (typeof value === 'number' ? value.toFixed(2) : value) },
        legend: {
          data: ['实时逐日雨量', '实时流量'],
          textStyle: { color: '#fff' },
          top: 10
        },
        xAxis: {
          type: 'category',
          data: timeList,
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' }
        },
        yAxis: [{
          type: 'value',
          name: '雨量(mm)',
          axisLabel: { color: '#ccc' },
          splitLine: { show: false }
        }, {
          type: 'value',
          name: '流量(m³/s)',
          axisLine: { lineStyle: { color: '#fff' } },
          axisLabel: { color: '#ccc' },
          splitLine: { lineStyle: { color: '#555', type: 'dashed' } }
        }],
        series: [
          {
            name: '实时逐日雨量',
            type: 'line',
            data: dayRainDataList,
            smooth: true,
            itemStyle: { color: '#00d8ff' },
            lineStyle: { width: 2 },
            label: { show: true, position: 'top', color: '#00d8ff', fontSize: 10, formatter: (p) => (typeof p.value === 'number' ? p.value.toFixed(2) : p.value) }
          },
          {
            name: '实时流量',
            type: 'line',
            yAxisIndex: 1,
            data: realFlowData,
            smooth: true,
            itemStyle: { color: '#ffaa00' },
            lineStyle: { width: 2 },
            label: { show: true, position: 'top', color: '#ffaa00', fontSize: 10, formatter: (p) => (typeof p.value === 'number' ? p.value.toFixed(2) : p.value) }
          }
        ]
      }
      this.rainfallChartInstance.setOption(option, { notMerge: true, lazyUpdate: true })
    },

    initMap() {
      this.mapData = new MapCreate()
      this.mapData.init('homeMap')
      this.fetchDrainGeoJSON()
      createWaterSystemLayer(this.mapData.map).addTo(this.mapData.map)
      this.fetchStationMarkers()
    },

    // 根据 getHydroSearch 返回的站点列表，加载各站点对应的流域面 json（不存在的文件自动跳过）
    fetchDrainFeatures() {
      return axios({
        url: `${API_BASE}/api/hydro/getHydroSearch`,
        method: 'get',
        params: {
          find: this.effectiveStationId || ''
        }
      }).then((res) => {
        if (res.data.code != 200 || !res.data.data || res.data.data.length === 0) {
          return []
        }
        const finds = res.data.data.map(s => s.find).filter(f => f)
        return Promise.all(
          finds.map(find =>
            axios({ url: getStationBasinURL(find), method: 'get' })
              .then(r => {
                const d = r.data
                if (!d) return []
                // 兼容两种 GeoJSON 结构：
                // FeatureCollection → features；GeometryCollection → geometries（如 513211.json）
                if (Array.isArray(d.features)) return d.features
                if (Array.isArray(d.geometries)) return d.geometries
                if (Array.isArray(d)) return d
                return []
              })
              .catch(() => [])
          )
        ).then((groups) => {
          return [].concat(...groups)
        })
      }).catch((error) => {
        console.error('获取流域面数据失败:', error)
        return []
      })
    },

    fetchDrainGeoJSON() {
      if (!this.mapData || !this.mapData.map) return
      const seq = ++this.drainReqSeq
      const stationId = this.effectiveStationId || ''
      this.fetchDrainFeatures().then((allFeatures) => {
        // 迟到响应直接丢弃，避免出现"B 站格点配 A 站边界"
        if (seq !== this.drainReqSeq || stationId !== (this.effectiveStationId || '')) return
        if (!this.mapData || !this.mapData.map) return
        if (this.drainLayer) {
          this.mapData.map.removeLayer(this.drainLayer)
          this.drainLayer = null
        }
        if (allFeatures.length === 0) return
        this.drainLayer = L.geoJSON(allFeatures, {
          color: 'red',
          fillOpacity: 0,
          className: 'dashLine'
        }).addTo(this.mapData.map)
      })
    },

    fetchStationMarkers() {
      const seq = ++this.markerReqSeq
      const stationId = this.effectiveStationId || ''
      axios({
        url: `${API_BASE}/api/hydro/getHydroSearch`,
        method: 'get',
        params: {
          find: stationId
        }
      }).then((res) => {
        // 迟到响应直接丢弃：切站后旧站标记不再画回地图
        if (seq !== this.markerReqSeq || stationId !== (this.effectiveStationId || '')) return
        if (res.data.code != 200) {
          console.warn('获取水电站标记数据失败:', res.data.message)
          return
        }
        const data = res.data.data
        if (data && data.length > 0) {
          this.stationOptions = data
          this.addStationMarkers(data)
        }
      }).catch((error) => {
        console.error('获取水电站标记数据失败:', error)
      })
    },

    addStationMarkers(stationList, targetMap = this.mapData && this.mapData.map) {
      if (!targetMap) return
      const isMainMap = this.mapData && targetMap === this.mapData.map
      if (isMainMap && this.stationMarkersLayer) {
        this.mapData.map.removeLayer(this.stationMarkersLayer)
        this.stationMarkersLayer = null
      }

      const stationMarkersLayer = L.layerGroup()

      // 新增水电站（后端暂未收录，硬编码追加）
      // const extraStations = [
      //   { station_name: '龙湖水电站', lon: '103.6709', lat: '32.0388', img: stationIcon, content: '龙湖水电站' },
      //   { station_name: '剑科水电站', lon: '103.613043', lat: '32.582708', img: stationIcon, content: '剑科水电站' },
      //   { station_name: '晴朗水电站', lon: '103.167778', lat: '32.417222', img: stationIcon, content: '晴朗水电站' },
      //   { station_name: '毛尔盖水电站', lon: '103.365168', lat: '31.966738', img: stationIcon, content: '毛尔盖水电站' }
      // ]
      // const allStations = (stationList || []).concat(extraStations)
      const allStations = stationList

      allStations.forEach((station) => {
        const lon = parseFloat(station.lon)
        const lat = parseFloat(station.lat)
        if (isNaN(lon) || isNaN(lat)) return

        const myIcon = L.icon({
          iconUrl: stationIcon,
          iconSize: [32, 32],
          iconAnchor: [16, 32],
          popupAnchor: [0, -32]
        })

        const marker = L.marker([lat, lon], { icon: myIcon })
        if (station.station_name) {
          const label = document.createElement('span')
          label.textContent = station.station_name
          marker.bindTooltip(label, {
            permanent: true,
            direction: 'right',
            offset: [18, -16],
            opacity: 1,
            className: 'hydro-station-name'
          })
        }
        marker.bindPopup(`
          <div style="min-width: 220px; text-align: center;">
            <div style="font-weight: bold; font-size: 14px; margin-bottom: 8px; color: #333;">
              ${station.station_name}
            </div>
            <img src="${station.img}" style="width: 200px; height: 130px; object-fit: cover; border-radius: 4px; margin-bottom: 8px;" />
            <div style="font-size: 12px; color: #666; line-height: 1.5;">
              ${station.content}
            </div>
          </div>
        `)
        stationMarkersLayer.addLayer(marker)
      })

      stationMarkersLayer.addTo(targetMap)
      if (isMainMap) {
        this.stationMarkersLayer = stationMarkersLayer
      }
      return stationMarkersLayer
    },

    getGridData() {
      if (!this.mapData || !this.mapData.map) return
      const seq = ++this.gridReqSeq
      const stationId = this.effectiveStationId || ''
      this.resetRainfallForecast()
      this.rainfallLoading = true
      const formData = new FormData()
      formData.append('Time', this.getLatestRainfallDate())
      formData.append('find', stationId)
      return axios({
        url: GRID_RAINFALL_FORECAST_URL,
        method: 'post',
        data: formData
      }).then((res) => {
        // 迟到响应直接丢弃：期间发生过切站/清数据/新请求
        if (seq !== this.gridReqSeq || stationId !== (this.effectiveStationId || '') || !this.mapData || !this.mapData.map) return

        if ((res.data.code != 200 && res.data.status != 200) && !res.data.success) {
          this.$message.warning(res.data.message || '获取格点数据失败')
          return
        }

        this.rainfallFrames = this.normalizeRainfallFrames(res.data.data)
        if (!this.rainfallFrames.length) {
          this.$message.warning('暂无有效的格点预报数据')
          return
        }
        this.renderRainfallFrame(true)
      }).catch(() => {
        if (seq === this.gridReqSeq) console.error('获取格点预报失败')
      }).finally(() => {
        if (seq === this.gridReqSeq) this.rainfallLoading = false
      })
    },

    normalizeRainfallFrames(rows) {
      if (!Array.isArray(rows)) return []
      const frames = new Map()
      rows.forEach(row => {
        if (!row || typeof row.fTime !== 'string' || typeof row.datas !== 'string') return
        const date = row.fTime.slice(0, 10)
        if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return
        const cols = Number(row.cols)
        const countRows = Number(row.rows)
        if (!Number.isInteger(cols) || !Number.isInteger(countRows) || cols < 1 || countRows < 1) return
        const bounds = ['left', 'right', 'top', 'bottom']
        if (bounds.some(key => row[key] == null || row[key] === '' || !Number.isFinite(Number(row[key])))) return
        if (Number(row.right) <= Number(row.left) || Number(row.top) <= Number(row.bottom)) return
        const values = row.datas.split(',')
        if (values.length !== cols * countRows || values.some(value => !value.trim() || !Number.isFinite(Number(value)))) return
        const previous = frames.get(date)
        // 同一预报日出现多个批次时保留较新的起报日期。
        if (!previous || String(row.dTime || '') >= String(previous.data.dTime || '')) {
          frames.set(date, { data: { ...row, fTime: date }, values: values.map(Number) })
        }
      })
      return [...frames.values()].sort((a, b) => a.data.fTime.localeCompare(b.data.fTime))
    },

    pauseRainfallPlayback() {
      if (this.rainfallTimer != null) clearInterval(this.rainfallTimer)
      this.rainfallTimer = null
      this.rainfallPlaying = false
    },

    toggleRainfallPlayback() {
      if (this.rainfallPlaying) {
        this.pauseRainfallPlayback()
        return
      }
      if (this.rainfallLoading || this.rainfallFrames.length < 2) return
      this.rainfallPlaying = true
      this.rainfallTimer = setInterval(() => {
        this.rainfallFrameIndex = (this.rainfallFrameIndex + 1) % this.rainfallFrames.length
        this.renderRainfallFrame()
      }, 2000)
    },

    seekRainfallFrame(index) {
      if (!Number.isInteger(index) || index < 0 || index >= this.rainfallFrames.length) return
      this.pauseRainfallPlayback()
      this.rainfallFrameIndex = index
      this.renderRainfallFrame()
    },

    clearFullscreenGridLayers() {
      const map = this.mapFullscreenInstance && this.mapFullscreenInstance.map
      if (map) {
        this.fullscreenGridLayers.forEach(layer => map.removeLayer(layer))
        if (this.fullscreenGridLegend) map.removeControl(this.fullscreenGridLegend)
      }
      this.fullscreenGridLayers = []
      this.fullscreenGridLegend = null
    },

    resetRainfallForecast() {
      this.pauseRainfallPlayback()
      this.rainfallFrames = []
      this.rainfallFrameIndex = 0
      this.gridDataCache = null
      this.gridListCache = null
      const map = this.mapData && this.mapData.map
      const layerKeys = ['gridDataLayer', 'gridLinesLayer', 'gridValuesLayer']
      layerKeys.forEach(key => {
        if (map && this[key]) map.removeLayer(this[key])
        this[key] = null
      })
      if (map && this.gridLegend) map.removeControl(this.gridLegend)
      this.gridLegend = null
      this.clearFullscreenGridLayers()
    },

    renderRainfallFrame(fitBounds = false) {
      const frame = this.rainfallFrames[this.rainfallFrameIndex]
      if (!frame) return
      this.gridDataCache = frame.data
      this.gridListCache = frame.values
      const map = this.mapData && this.mapData.map
      if (map) {
        const layerKeys = ['gridDataLayer', 'gridLinesLayer', 'gridValuesLayer']
        layerKeys.forEach(key => {
          if (this[key]) map.removeLayer(this[key])
        })
        const layers = this.renderGridFrame(map, frame, fitBounds)
        this.gridDataLayer = layers[0]
        this.gridLinesLayer = layers[1]
        this.gridValuesLayer = layers[2]
        if (!this.gridLegend) this.addGridLegend()
      }
      this.renderFullscreenRainfallFrame(fitBounds)
    },

    renderFullscreenRainfallFrame(fitBounds = false) {
      const map = this.mapFullscreenInstance && this.mapFullscreenInstance.map
      const frame = this.rainfallFrames[this.rainfallFrameIndex]
      if (!map || !frame) return
      this.fullscreenGridLayers.forEach(layer => map.removeLayer(layer))
      this.fullscreenGridLayers = this.renderGridFrame(map, frame, fitBounds)
      if (!this.fullscreenGridLegend) {
        this.fullscreenGridLegend = this.createGridLegendControl()
        this.fullscreenGridLegend.addTo(map)
      }
    },

    renderGridFrame(map, frame, fitBounds) {
      const gridData = frame.data
      const gridList = frame.values
      // 仅初次加载定位；拖动进度和播放时保留用户当前视野。
      if (fitBounds) map.fitBounds([[gridData.bottom, gridData.left], [gridData.top, gridData.right]], { animate: false })
      const tileLayer = L.tilePixelLayer({
          newData: gridList,
          data: gridData,
          gradient: this.getAdjustedRainGradient(),
          clickEvt: (e, gridValue) => {
            L.popup({
              autoPanPaddingBottomRight: L.point(600, 0),
              closeButton: true
            })
              .setLatLng([e.latlng.lat, e.latlng.lng])
              .setContent(`
                <div style="text-align: center;">
                  <div style="font-weight: bold; margin-bottom: 5px;">格点信息</div>
                  <div>经度: ${e.latlng.lng.toFixed(4)}</div>
                  <div>纬度: ${e.latlng.lat.toFixed(4)}</div>
                  <div style="color: #409eff; font-weight: bold; margin-top: 5px;">
                    雨量值: ${gridValue} mm
                  </div>
                </div>
              `)
              .openOn(map)
          }
        })

      map.addLayer(tileLayer)
      const overlays = this.buildGridOverlayLayers(gridData, gridList)
      if (!overlays) return [tileLayer]
      overlays.linesLayer.addTo(map)
      overlays.valuesLayer.addTo(map)
      return [tileLayer, overlays.linesLayer, overlays.valuesLayer]
    },

    addGridLegend() {
      if (this.gridLegend) {
        this.mapData.map.removeControl(this.gridLegend)
      }

      this.gridLegend = this.createGridLegendControl()
      this.gridLegend.addTo(this.mapData.map)
    },

    // 生成雨量图例控件（主图与全屏地图共用）
    createGridLegendControl() {
      const control = L.control({ position: 'bottomright' })
      control.onAdd = () => {
        const div = L.DomUtil.create('div', 'grid-legend')
        div.style.pointerEvents = 'auto'
        div.innerHTML = `
          <div style="
            background: rgba(0, 0, 0, 0.75);
            padding: 10px 12px;
            border-radius: 4px;
            border: 1px solid rgba(0, 216, 255, 0.3);
            box-shadow: 0 2px 12px rgba(0,0,0,0.5);
            font-size: 12px;
            color: #eee;
            min-width: 100px;
          ">
            <div style="font-weight: bold; margin-bottom: 8px; color: #00d8ff; font-size: 13px;">雨量图例 (mm)</div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #FFFFFF; margin-right: 8px; border-radius: 2px; border: 1px solid #555;"></span>
              <span style="color: #ddd;">无降水</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #91EE91; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">0.1~10 小雨</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #22B122; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">10~25 中雨</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #46AAFF; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">25~50 大雨</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #0000DC; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">50~100 暴雨</span>
            </div>
            <div style="display: flex; align-items: center; margin-bottom: 5px;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #E600E6; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">100~250 大暴雨</span>
            </div>
            <div style="display: flex; align-items: center;">
              <span style="display: inline-block; width: 24px; height: 14px; background: #78003C; margin-right: 8px; border-radius: 2px;"></span>
              <span style="color: #ddd;">≥250 特大暴雨</span>
            </div>
          </div>
        `
        return div
      }
      return control
    },

    // 主图：构建格线/数值叠加层并挂到当前地图
    addGridLinesAndValues(gridData, gridList) {
      if (this.gridLinesLayer) {
        this.mapData.map.removeLayer(this.gridLinesLayer)
        this.gridLinesLayer = null
      }
      if (this.gridValuesLayer) {
        this.mapData.map.removeLayer(this.gridValuesLayer)
        this.gridValuesLayer = null
      }

      const layers = this.buildGridOverlayLayers(gridData, gridList)
      if (!layers) return

      this.gridLinesLayer = layers.linesLayer
      this.gridValuesLayer = layers.valuesLayer
      this.gridLinesLayer.addTo(this.mapData.map)
      this.gridValuesLayer.addTo(this.mapData.map)
    },

    // 构建格线/数值叠加层（主图与全屏地图共用）
    // 位置与渲染层保持一致（见 src/map/index.js 的 png2GridData）：
    //   经度样点 lon_i = left + i * dx，dx = (right - left) / cols
    //   纬度样点 lat_j = top - j * dy，dy = (top - bottom) / (rows - 1)（top/bottom 为最边行样点位置）
    // 行列缺失时按数据量推算；数量不完全匹配时降级绘制，尽量正常显示
    buildGridOverlayLayers(gridData, gridList) {
      let cols = Number(gridData.cols)
      let rows = Number(gridData.rows)
      if (!cols || !rows) {
        cols = Math.round(Math.sqrt(gridList.length))
        rows = Math.round(gridList.length / (cols || 1))
      }
      if (!cols || !rows) {
        console.warn('格点行列数无法推算，跳过格线/数值绘制:', gridList.length)
        return null
      }
      if (cols * rows !== gridList.length) {
        console.warn('格点行列数与数据数量不一致，降级绘制:', cols, rows, gridList.length)
      }

      const left = Number(gridData.left)
      const right = Number(gridData.right)
      const top = Number(gridData.top)
      const bottom = Number(gridData.bottom)
      const lonStep = (right - left) / cols
      const latStep = rows > 1 ? (top - bottom) / (rows - 1) : 0

      const linesLayer = L.layerGroup()
      for (let i = 0; i < cols; i++) {
        const lon = left + i * lonStep
        linesLayer.addLayer(
          L.polyline([[bottom, lon], [top, lon]], {
            color: 'rgba(255, 255, 255, 0.5)',
            weight: 1
          })
        )
      }
      for (let j = 0; j < rows; j++) {
        const lat = top - j * latStep
        linesLayer.addLayer(
          L.polyline([[lat, left], [lat, right]], {
            color: 'rgba(255, 255, 255, 0.5)',
            weight: 1
          })
        )
      }

      const valuesLayer = L.layerGroup()
      for (let j = 0; j < rows; j++) {
        for (let i = 0; i < cols; i++) {
          const index = j * cols + i
          if (index >= gridList.length) break
          const value = parseFloat(gridList[index])
          if (!isNaN(value)) {
            const lon = left + i * lonStep
            const lat = top - j * latStep

            const icon = L.divIcon({
              className: 'grid-value-label',
              html: `<div style="
                color: #fff;
                font-size: 10px;
                font-weight: bold;
                text-shadow: 1px 1px 2px rgba(0,0,0,0.8);
                white-space: nowrap;
              ">${value.toFixed(2)}</div>`,
              iconSize: [30, 12],
              iconAnchor: [15, 6]
            })

            valuesLayer.addLayer(L.marker([lat, lon], { icon: icon, interactive: false }))
          }
        }
      }

      return { linesLayer, valuesLayer }
    },

    getAdjustedRainGradient() {
      const opacity = this.gridOpacity / 255
      return legendColor['rain'].map(([threshold, color]) => {
        return [threshold, [color[0], color[1], color[2], color[3] * opacity]]
      })
    },

    updateGridOpacity(e) {
      this.gridOpacity = Number(e.target.value)
      this.renderRainfallFrame()
    },

    clearGridData() {
      // 递增所有请求代际，使在途的迟到响应直接丢弃，防止旧站数据画回地图
      this.gridReqSeq++
      this.drainReqSeq++
      this.markerReqSeq++
      this.fetchReqSeq++
      this.resetRainfallForecast()
      this.rainfallLoading = false
      if (this.stationMarkersLayer && this.mapData && this.mapData.map) {
        this.mapData.map.removeLayer(this.stationMarkersLayer)
        this.stationMarkersLayer = null
      }
      if (this.drainLayer && this.mapData && this.mapData.map) {
        this.mapData.map.removeLayer(this.drainLayer)
        this.drainLayer = null
      }
    },

  }
}
</script>
<style>
.leaflet-tooltip.hydro-station-name {
  padding: 3px 7px;
  color: #17324d;
  background: rgba(255, 255, 255, 0.92);
  border: 1px solid rgba(23, 50, 77, 0.2);
  border-radius: 4px;
  font-size: 13px;
  font-weight: 600;
  line-height: 20px;
  white-space: nowrap;
  pointer-events: none;
}

.leaflet-tooltip-right.hydro-station-name::before {
  display: none;
}
</style>

<style scoped>
.homeViewBody {
  height: 100vh;
  background-image: url('../assets/interact.png');
  background-size: 100% 100%;
  width: 100vw;
}

.homeViewHeader {
  height: 10vh;
  color: white;
  width: 100vw;
  line-height: 8vh;
  font-size: 35px;
  font-weight: 700;
  text-align: center;
  position: relative;
}

.timeBox {
  height: 5vh;
  width: 30%;
  position: absolute;
  left: 0;
  top: 3vh;
  font-size: 18px;
  text-align: left;
  font-weight: 600;
  padding-left: 15px;
  line-height: 5vh;
  color: white;
}

.locBox {
  height: 5vh;
  width: 30%;
  position: absolute;
  right: 0;
  top: 3vh;
  font-size: 18px;
  text-align: right;
  font-weight: 600;
  padding-right: 15px;
  line-height: 5vh;
  color: #05D4EC;
}

.homeMainBox {
  height: 90vh;
  width: 100vw;
  position: relative;
  padding: 10px;
  box-sizing: border-box;
}

.mainLayout {
  display: flex;
  height: 100%;
  gap: 10px;
}

.leftColumn {
  width: 26%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.centerColumn {
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.rightColumn {
  width: 26%;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.leftColumn .card,
.rightColumn .card {
  flex: 1;
}

.centerColumn .map-card {
  flex: 2;
}

.centerColumn .card:not(.map-card) {
  flex: 1;
}

.card {
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 18px;
  font-weight: 600;
  position: relative;
}

.card > div {
  width: 100%;
  height: 100%;
}

.chart-container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 10px;
  box-sizing: border-box;
}

.chart-title {
  color: #009ECA;
  font-size: 16px;
  font-weight: 600;
  position: absolute;
  left: 20px;
  top: 10px;
  text-align: center;
}

.chart-content {
  flex: 1;
  width: 100%;
  height: 100%;
  min-height: 200px;
}

.radio-group {
  display: flex;
  gap: 0;
  margin-bottom: 10px;
}

.radio-label {
  color: #a8d8ea;
  font-size: 13px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 6px 18px;
  border: 1px solid rgba(0, 216, 255, 0.3);
  border-radius: 4px;
  transition: all 0.3s;
  background: rgba(0, 216, 255, 0.05);
}

.radio-label:first-child {
  border-radius: 4px 0 0 4px;
  border-right: none;
}

.radio-label:last-child {
  border-radius: 0 4px 4px 0;
}

.radio-label:hover {
  border-color: #00d8ff;
  color: #00d8ff;
}

.radio-label input[type="radio"] {
  display: none;
}

.radio-label:has(input:checked) {
  background: rgba(0, 216, 255, 0.2);
  border-color: #00d8ff;
  color: #00d8ff;
}

.operation-content {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 18px;
  padding: 10px 5px;
}

.operation-item {
  display: flex;
  align-items: center;
  width: 100%;
  justify-content: center;
  gap: 12px;
}

.operation-item2 {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 10px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 4px;
}

.operation-item3 {
  width: 100%;
  display: flex;
  align-items: center;
  gap: 12px;
  justify-content: center;
  flex-wrap: wrap;
  margin-top: 2px;
}

.operation-item .label {
  color: #a8d8ea;
  font-size: 13px;
  font-weight: 500;
  min-width: 60px;
  text-align: right;
  letter-spacing: 0.5px;
}

.operation-item .station-name {
  color: #00d8ff;
  font-size: 14px;
  font-weight: 600;
  width: 200px;
  text-align: left;
  padding: 8px 16px;
  background: rgba(0, 216, 255, 0.08);
  border: 1px solid rgba(0, 216, 255, 0.2);
  border-radius: 4px;
}

.operation-item .radio-group {
  margin-bottom: 0;
}

.confirm-btn {
  background: linear-gradient(135deg, #00d8ff 0%, #0088cc 100%);
  color: #fff;
  border: none;
  padding: 10px 55px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s;
  letter-spacing: 2px;
  box-shadow: 0 2px 12px rgba(0, 216, 255, 0.3);
}

.confirm-btn:hover {
  background: linear-gradient(135deg, #00e8ff 0%, #0099dd 100%);
  box-shadow: 0 4px 18px rgba(0, 216, 255, 0.5);
  transform: translateY(-1px);
}

.confirm-btn.green {
  background-color: #00c853;
  color: #fff;
}

.confirm-btn.green:hover {
  background-color: #00a344;
}

.text-btn {
  background: rgba(0, 216, 255, 0.06);
  color: #a8d8ea;
  border: 1px solid rgba(0, 216, 255, 0.25);
  padding: 9px 24px;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  letter-spacing: 0.5px;
}

.text-btn:hover {
  background-color: rgba(0, 216, 255, 0.15);
  border-color: #00d8ff;
  color: #00d8ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 216, 255, 0.2);
}

.text-btn .el-icon-link {
  font-size: 16px;
}

.chart-actions {
  position: absolute;
  right: 20px;
  top: 10px;
  display: flex;
  gap: 10px;
  z-index: 99;
}

.action-btn {
  background-color: transparent;
  color: #fff;
  border: none;
  padding: 6px 15px;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
  /* transition: background-color 0.3s; */
}

.action-btn:hover {
  background-color: #00a8cc;
}

.action-btn.icon-only {
  padding: 6px 10px;
  font-size: 16px;
  line-height: 1;
}

.table-content {
  width: 100%;
  height: 300px;
  overflow-y: auto;
  margin-top: 50px;
}

.table-content table {
  width: 100%;
  border-collapse: collapse;
  font-size: 12px;
}

.table-content th,
.table-content td {
  border: 1px solid #555;
  padding: 8px;
  text-align: center;
  color: #fff;
}

.table-content th {
  background-color: #006e99;
  font-weight: 600;
}

.table-content tbody tr:nth-child(even) {
  background-color: rgba(0, 216, 255, 0.1);
}

.table-content tbody tr:hover {
  background-color: rgba(0, 216, 255, 0.2);
}

.el-input__inner {
  background-color: transparent !important;
  color: #00d8ff !important;
  border-color: #00d8ff !important;
}

.el-icon-date {
  color: #00d8ff !important;
}

.myheaderBtnBox {
  height: 30px;
  width: 650px;
  position: absolute;
  right: 0;
  top: 5vh;
  z-index: 999;
  display: flex;
  justify-content: space-between;
}

.myheaderBtnitem {
  height: 30px;
  flex: 1;
  color: #07D8FE;
  border: none;
  font-size: 18px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 4px;
  line-height: 30px;
  margin-left: 15px;
}

.myheaderBtnitem:hover {
  color: #fff;
  text-shadow: 0 0 10px rgba(7, 216, 254, 0.8);
}

.warning-banner {
  position: fixed;
  top: 80px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 2000;
  max-width: 600px;
  width: 90%;
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding: 10px 16px;
  border-radius: 8px;
  backdrop-filter: blur(8px);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
  animation: warningSlideIn 0.3s ease-out;
}

.warning-orange {
  background: rgba(230, 162, 60, 0.2);
  border: 1px solid rgba(230, 162, 60, 0.5);
}

.warning-orange .warning-icon i {
  color: #e6a23c;
}

.warning-red {
  background: rgba(245, 108, 108, 0.2);
  border: 1px solid rgba(245, 108, 108, 0.5);
}

.warning-red .warning-icon i {
  color: #f56c6c;
}

.warning-yellow {
  background: rgba(231, 200, 42, 0.2);
  border: 1px solid rgba(231, 200, 42, 0.5);
}

.warning-yellow .warning-icon i {
  color: #e7c82a;
}

.warning-blue {
  background: rgba(64, 158, 255, 0.2);
  border: 1px solid rgba(64, 158, 255, 0.5);
}

.warning-blue .warning-icon i {
  color: #409eff;
}

.warning-icon {
  flex-shrink: 0;
  padding-top: 2px;
}

.warning-icon i {
  font-size: 20px;
}

.warning-content {
  flex: 1;
  min-width: 0;
}

.warning-headline {
  font-size: 14px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 2px;
}

.warning-desc {
  font-size: 11px;
  color: rgba(255, 255, 255, 0.75);
  line-height: 1.4;
}

.warning-close {
  flex-shrink: 0;
  cursor: pointer;
  padding: 2px;
  opacity: 0.5;
  transition: opacity 0.2s;
}

.warning-close:hover {
  opacity: 1;
}

.warning-close i {
  color: #fff;
  font-size: 14px;
}

@keyframes warningSlideIn {
  from { opacity: 0; transform: translateX(30px); }
  to { opacity: 1; transform: translateX(0); }
}

.user-menu {
  display: flex;
  align-items: center;
  justify-content: center;
}

.user-menu i {
  margin-right: 5px;
  font-size: 16px;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  border-radius: 8px;
}

.loading-spinner {
  text-align: center;
  color: #00d8ff;
}

.loading-spinner i {
  font-size: 48px;
  animation: rotate 2s linear infinite;
}

.loading-spinner p {
  margin-top: 12px;
  font-size: 16px;
  letter-spacing: 2px;
}

@keyframes rotate {
  from { transform: rotate(0deg); }
  to { transform: rotate(360deg); }
}

.map-container {
  position: relative;
}

.map-header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 10px;
  margin-bottom: 5px;
}

.map-header-row .chart-title {
  position: static;
  margin-bottom: 0;
}

.map-header-controls {
  display: flex;
  align-items: center;
  gap: 8px;
}

.map-opacity-slider {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 4px 10px 6px 10px;
  background: rgba(0, 20, 40, 0.6);
  border-top: 1px solid rgba(0, 216, 255, 0.2);
}

.map-opacity-slider .opacity-label {
  font-size: 11px;
  color: #ccc;
  white-space: nowrap;
}

.map-opacity-slider .opacity-range {
  flex: 1;
  height: 4px;
  cursor: pointer;
  accent-color: #00d8ff;
}

.map-opacity-slider .opacity-value {
  font-size: 11px;
  color: #00d8ff;
  min-width: 36px;
  text-align: right;
}

.map-mode-select {
  width: 100px;
  z-index: 999;
}

.map-date-select {
  width: 150px;
  z-index: 999;
}

.map-chart {
  flex: 1;
  width: 100%;
  min-height: 250px;
  border-radius: 4px;
  overflow: hidden;
}

.map-chart >>> .leaflet-control-attribution {
  display: none;
}

.map-chart >>> .dashLine {
  stroke-dasharray: 5 5;
  fill: none;
  stroke-width: 2;
}

.map-chart >>> .dashLine path {
  stroke-dasharray: 5 5;
}

.fullscreen-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.85);
  z-index: 9999;
  display: flex;
  justify-content: center;
  align-items: center;
}

.fullscreen-chart-container {
  width: 95vw;
  height: 90vh;
  background: rgba(10, 20, 40, 0.95);
  border: 2px solid rgba(0, 216, 255, 0.5);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 40px rgba(0, 216, 255, 0.3);
}

.fullscreen-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 25px;
  border-bottom: 1px solid rgba(0, 216, 255, 0.2);
}

.fullscreen-title {
  color: #00d8ff;
  font-size: 22px;
  font-weight: 700;
}

.fullscreen-close-btn {
  background: rgba(0, 216, 255, 0.15);
  color: #00d8ff;
  border: 1px solid rgba(0, 216, 255, 0.4);
  padding: 8px 22px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  border-radius: 6px;
  transition: all 0.3s;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.fullscreen-close-btn:hover {
  background: rgba(0, 216, 255, 0.3);
  border-color: #00d8ff;
  box-shadow: 0 0 15px rgba(0, 216, 255, 0.4);
}

.fullscreen-chart-content {
  flex: 1;
  width: 100%;
}

.fullscreen-map-container {
  width: 95vw;
  height: 90vh;
  background: rgba(10, 20, 40, 0.95);
  border: 2px solid rgba(0, 216, 255, 0.5);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 0 40px rgba(0, 216, 255, 0.3);
}

.fullscreen-map-content {
  flex: 1;
  width: 100%;
}

.copyright-footer {
  text-align: center;
  padding: 8px 0 12px;
  font-size: 12px;
  color: rgba(255, 255, 255, 0.4);
  letter-spacing: 1px;
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
}
</style>
